import React from "react";



const PrivacyPolicy = () => (
  <>
    <section className="page-header">
      <h1>Datenschutz</h1>
    </section>
    <section className="privacy-policy-section" style={{maxWidth: 800, margin: "3rem auto", background: "black", color: "#222", borderRadius: 4, padding: "2.5rem 1.5rem"}}>
      <h3>Erklärung zur Informationspflicht</h3>
    <p style={{textAlign: "center"}}><strong>Datenschutzerklärung</strong></p>
    <p>
      In folgender Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Webseite. Wir erheben und verarbeiten personenbezogene Daten nur auf Grundlage der gesetzlichen Bestimmungen (Datenschutzgrundverordnung, Telekommunikationsgesetz 2003).
    </p>
    <p>
      Sobald Sie als Benutzer auf unsere Webseite zugreifen oder diese besuchen, wird Ihre IP-Adresse, Beginn sowie Beginn und Ende der Sitzung erfasst. Dies ist technisch bedingt und stellt somit ein berechtigtes Interesse iSv Art 6 Abs 1 lit f DSGVO dar.
    </p>

    <h5>Kontakt mit uns</h5>
    <p>
      Wenn Sie uns, entweder über unser Kontaktformular auf unserer Webseite, oder per Email kontaktieren, dann werden die von Ihnen an uns übermittelten Daten zwecks Bearbeitung Ihrer Anfrage oder für den Fall von weiteren Anschlussfragen für sechs Monate bei uns gespeichert. Es erfolgt, ohne Ihre Einwilligung, keine Weitergabe Ihrer übermittelten Daten.
    </p>

    <h5>Cookies</h5>
    <p>
      Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an. Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen. Wenn Sie dies nicht wünschen, so können Sie Ihren Browser so einrichten, dass er Sie über das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben. Bei der Deaktivierung von Cookies kann die Funktionalität unserer Website eingeschränkt sein.
    </p>
    <h5>Cookie-Einstellungen widerrufen</h5>
    <p>
      Sie können Ihre Cookie-Einstellungen jederzeit ändern oder widerrufen:
    </p>
    <button
  style={{
    background: "#ffa726",
    color: "#222",
    fontWeight: "bold",
    fontSize: "1.08rem",
    borderRadius: "8px",
    padding: "0.7rem 2rem",
    border: "none",
    cursor: "pointer",
    marginBottom: "1.5rem"
  }}
  onClick={() => {
    // Cookie löschen (Name ggf. anpassen, Standard ist 'CookieConsent')
    document.cookie = "CookieConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    window.location.reload();
  }}
>
  Cookie-Einstellungen ändern
</button>

    <h5>Google Fonts</h5>
    <p>
      Unsere Website verwendet Schriftarten von „Google Fonts“. Der Dienstanbieter dieser Funktion ist:
    </p>
    <ul>
      <li>Google Ireland Limited Gordon House, Barrow Street Dublin 4. Ireland</li>
    </ul>
    <p>Tel: +353 1 543 1000</p>
    <p>
      Beim Aufrufen dieser Webseite lädt Ihr Browser Schriftarten und speichert diese in den Cache. Da Sie, als Besucher der Webseite, Daten des Dienstanbieters empfangen, kann Google unter Umständen Cookies auf Ihrem Rechner setzen oder analysieren.
    </p>
    <p>
      Die Nutzung von „Google-Fonts“ dient der Optimierung unserer Dienstleistung und der einheitlichen Darstellung von Inhalten. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
    </p>
    <p>Weitere Informationen zu Google Fonts erhalten Sie unter folgendem Link:</p>
    <ul>
      <li>
        <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer" style={{color:"#ffa726"}}>
          https://developers.google.com/fonts/faq
        </a>
      </li>
    </ul>
    <p>Weitere Informationen über den Umgang mit Nutzerdaten von Google können Sie der Datenschutzerklärung entnehmen:</p>
    <ul>
      <li>
        <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" style={{color:"#ffa726"}}>
          https://policies.google.com/privacy?hl=de
        </a>
      </li>
    </ul>
    <p>
      Google verarbeitet die Daten auch in den USA, hat sich jedoch dem EU-US Privacy-Shield unterworfen.
    </p>
    <p>
      <a href="https://www.privacyshield.gov/EU-US-Framework" target="_blank" rel="noopener noreferrer" style={{color:"#ffa726"}}>
        https://www.privacyshield.gov/EU-US-Framework
      </a>
    </p>

    <h5>Server-Log Files</h5>
    <p>
      Diese Webseite und der damit verbundene Provider erhebt im Zuge der Webseitennutzung automatisch Informationen im Rahmen sogenannter „Server-Log Files“. Dies betrifft insbesondere:
    </p>
    <ul>
      <li>IP-Adresse oder Hostname</li>
      <li>den verwendeten Browser</li>
      <li>Aufenthaltsdauer auf der Webseite sowie Datum und Uhrzeit</li>
      <li>aufgerufene Seiten der Webseite</li>
      <li>Spracheinstellungen und Betriebssystem</li>
      <li>„Leaving-Page“ (auf welcher URL hat der Benutzer die Webseite verlassen)</li>
      <li>ISP (Internet Service Provider)</li>
    </ul>
    <p>
      Diese erhobenen Informationen werden nicht personenbezogen verarbeitet oder mit personenbezogenen Daten in Verbindung gebracht.
    </p>
    <p>
      Der Webseitenbetreiber behält es sich vor, im Falle von Bekanntwerden rechtswidriger Tätigkeiten, diese Daten auszuwerten oder zu überprüfen.
    </p>

    <h5>Ihre Rechte als Betroffener</h5>
    <p>Sie als Betroffener haben bezüglich Ihrer Daten, welche bei uns gespeichert sind, grundsätzlich ein Recht auf:</p>
    <ul>
      <li>Auskunft</li>
      <li>Löschung der Daten</li>
      <li>Berichtigung der Daten</li>
      <li>Übertragbarkeit der Daten</li>
      <li>Widerruf und Widerspruch zur Datenverarbeitung</li>
      <li>Einschränkung</li>
    </ul>
    <p>
      Wenn Sie vermuten, dass im Zuge der Verarbeitung Ihrer Daten Verstöße gegen das Datenschutzrecht passiert sind, so haben Sie die Möglichkeit, sich bei uns (<a href="mailto:felber98@gmx.at" style={{color:"#ffa726"}}>felber98@gmx.at</a>) oder der Datenschutzbehörde zu beschweren.
    </p>

    <h5>Sie erreichen uns unter folgenden Kontaktdaten:</h5>
    <p>
      <b>Webseitenbetreiber:</b> Michael Felber<br />
      <b>Email:</b> <a href="mailto:felber98@gmx.at" style={{color:"#ffa726"}}>felber98@gmx.at</a>
    </p>
    
  </section>
  </>
);

export default PrivacyPolicy;
